'use client'
import { createContext, useMemo, useReducer } from 'react'

const HeaderContext = createContext()

const headerReducer = (state, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_NAV_ITEM_INDEX':
      return {
        ...state,
        activeItemIndex: action.itemIndex,
      }
    case 'SET_MOBILE_NAV_OPEN':
      return {
        ...state,
        mobileNavOpen: action.open,
      }
    default:
      throw new Error(`Unhandled action type: ${action.type}`)
  }
}

const HeaderProvider = ({ children }) => {
  const [state, dispatch] = useReducer(headerReducer, {
    activeItemIndex: undefined,
    mobileNavOpen: false,
  })
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch])
  return <HeaderContext.Provider value={contextValue}>{children}</HeaderContext.Provider>
}

export { HeaderProvider, HeaderContext }
